import Stats from "stats.js"
// import Sleep from "@frog/source/utility/Sleep.js"

const dev = new class Dev {
    constructor() {
        this.isEnabled = true
        // this.isEnabled = false
        if(this.isEnabled != true) return

        // // Profiling
        // this.stats = new Stats()
        // this.stats.dom.style.position = "absolute"
        // this.stats.dom.style.display = "flex"
        // this.stats.dom.style.zIndex = -1
        // Object.values(this.stats.dom.children).forEach((child) => child.style = "block")
        // this.stats.dom.addEventListener("click", (event) => event.stopPropagation(), true)
        // document.body.appendChild(this.stats.dom)

        // // Testing
        // import(/* webpackChunkName: "test.js" */"@frog/source/test.js")
        // import("@frog/source/utility/Testrecord.js")
        // Sleep(20 * 1000).then(() => import(/* webpackChunkName: "test.js" */"@frog/source/test.js"))
        // Sleep(2 * 1000).then(() => import(/* webpackChunkName: "test.js" */"@frog/source/test.js"))
        // require("@frog/source/test.js")
        // Sleep(1000).then(() => import("@frog/source/test.js"))
        // import("@frog/source/test.js")
        // import(/* webpackChunkName: "test.js" */"@frog/source/test.js")
    }
    atStartOfLoop() {
        if(this.stats != undefined) {
            if(this.isEnabled != true) return
            this.stats.begin()
        }
    }
    atEndOfLoop() {
        if(this.stats != undefined) {
            if(this.isEnabled != true) return
            this.stats.end()
        }
    }
}

export default dev
